import { Injectable } from '@angular/core';
import { SlateMessage, SlateSessionContext } from './slate.types';

@Injectable({ providedIn: 'root' })
export class SlateSessionService {
    context: SlateSessionContext = {};
    messages: SlateMessage[] = [];

    setContext(ctx: SlateSessionContext): void {
        this.context = { ...ctx };
    }

    clear(): void {
        this.context = {};
        this.messages = [];
    }

    addMessage(msg: SlateMessage): void {
        this.messages = [...this.messages, msg];
    }

    updateMessage(id: string, patch: Partial<SlateMessage>): void {
        this.messages = this.messages.map((m) =>
            m.id === id ? { ...m, ...patch } : m
        );
    }
}

